<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Luggage And Passengers</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form ref="luggageForm">
          <v-row dense class="ml-5">
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-text-field
                outlined
                dense
                :rules="maxSeatsRule"
                v-model="rideTypeLuggagePassengersForm.numSeats"
                label="Number of Passengers"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-text-field
                dense
                outlined
                v-model="rideTypeLuggagePassengersForm.maxLuggage"
                type="number"
                label="No of Luggage"
                :rules="luggageRule"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <SelectableBodyStyleInput :placeholder="'Select body type'" label="Body Type" @input="bodyTypeSelected"></SelectableBodyStyleInput>
            </v-col>
          </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-simple-table v-if="seatLuggageCombinations.length" dense>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">
                                    Passengers
                                </th>
                                <th class="text-left">
                                    Luggage
                                </th>
                                <th class="text-left">
                                    Body Type
                                </th>
                                <th class="text-left">
                                    Select
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="item in seatLuggageCombinations"
                                :key="item.name"
                            >
                                <td>{{ item.pax }}</td>
                                <td>{{ item.maxLug }}</td>
                                <td>{{ item.bodyType }}</td>
                                <td>
                                    <v-checkbox v-model="item.selected"></v-checkbox>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-alert
                        v-else
                        dense
                        type="info"
                    >
                        All Passengers Luggage configured.
                    </v-alert>
                </v-col>
            </v-row>
        </v-form>
        <v-card-actions class="py-0 px-4">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="updateRows"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectableBodyStyleInput from '@/components/widget/input/SelectableBodyStyleInput'
export default {
    name: "RideTypeLuggagePassengerForm",
    components: {SelectableBodyStyleInput},
    data() {
        return {
            bodyTypes: [{
                name: "Sal",
                type: "Saloon"
            },
                {
                    name: "Est",
                    type: "Estate"
                }, {
                    name: "Mpv",
                    type: "Mpv"
                }
            ],
            luggageRule: [(v) => !!v || "Luggage is required"],
            maxSeatsRule: [(v) => !!v || "No of Passengers is required"],
            rideTypeLuggagePassengersForm: {
                maxLuggage: '',
                numSeats: '',
                bodyType: '',
                rideTypeId: this.$route.params.id
            },
            combinations: [
                {pax: 1, maxLug: 3, bodyType: 'Estate'},
                {pax: 2, maxLug: 3, bodyType: 'Estate'},
                {pax: 3, maxLug: 3, bodyType: 'Estate'},
                {pax: 4, maxLug: 3, bodyType: 'Estate'},
                {pax: 1, maxLug: 4, bodyType: 'Estate'},
                {pax: 2, maxLug: 4, bodyType: 'Estate'},
                {pax: 3, maxLug: 4, bodyType: 'Estate'},
                {pax: 4, maxLug: 4, bodyType: 'Estate'},
                {pax: 1, maxLug: 3, bodyType: 'Saloon'},
                {pax: 2, maxLug: 3, bodyType: 'Saloon'},
                {pax: 3, maxLug: 3, bodyType: 'Saloon'},
                {pax: 4, maxLug: 3, bodyType: 'Saloon'},
                {pax: 1, maxLug: 5, bodyType: 'Mpv'},
                {pax: 2, maxLug: 5, bodyType: 'Mpv'},
                {pax: 3, maxLug: 5, bodyType: 'Mpv'},
                {pax: 4, maxLug: 5, bodyType: 'Mpv'},
                {pax: 5, maxLug: 2, bodyType: 'Mpv'},
                {pax: 6, maxLug: 1, bodyType: 'Mpv'},
                {pax: 1, maxLug: 4, bodyType: 'Mpv'},
                {pax: 2, maxLug: 4, bodyType: 'Mpv'},
                {pax: 3, maxLug: 4, bodyType: 'Mpv'},
                {pax: 4, maxLug: 4, bodyType: 'Mpv'},
                {pax: 1, maxLug: 10, bodyType: 'Mpv'},
                {pax: 2, maxLug: 10, bodyType: 'Mpv'},
                {pax: 3, maxLug: 10, bodyType: 'Mpv'},
                {pax: 4, maxLug: 10, bodyType: 'Mpv'},
                {pax: 5, maxLug: 10, bodyType: 'Mpv'},
                {pax: 6, maxLug: 10, bodyType: 'Mpv'},
                {pax: 7, maxLug: 10, bodyType: 'Mpv'},
                {pax: 8, maxLug: 10, bodyType: 'Mpv'}
            ]
        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: null
        },
        rideTypeInfo: {
            type: Object,
            default: null
        }
    },
    computed: {
        rideTypeCapacities() {
            return this.rideTypeInfo.rideTypeCapacity
        },
        seatLuggageCombinations() {
            return this.generateCombinations(this.rideTypeInfo.num_seats, this.rideTypeInfo.max_luggage)
        },
        selectedCombinations() {
            let selectedCombs = this.seatLuggageCombinations.filter(combo => {
                return combo.selected
            })
            let uniqueRows = []
            selectedCombs.forEach(combination => {
                if (!this.rideTypeCapacityRecordExistsForSelectedRow(combination)) {
                    uniqueRows.push(combination)
                }
            })
            return uniqueRows
        }
    },
    methods: {
        generateCombinations(max_seats, max_luggage) {
            let remainingCombs = []
            this.combinations.forEach(comb => {
                let exists = this.rideTypeCapacities.find (capacity => {
                    return capacity.max_luggage == comb.maxLug && capacity.num_seats == comb.pax && capacity.body_type == comb.bodyType
                })
                if (!exists) {
                    remainingCombs.push(comb)
                }
            })
            return remainingCombs.filter(combination => {
                return combination.pax <= max_seats && combination.maxLug <= max_luggage;
            });
        },
        rideTypeCapacityRecordExists() {
            let record = this.rideTypeCapacities.find(record => {
                return record.max_luggage == this.rideTypeLuggagePassengersForm.maxLuggage && record.num_seats == this.rideTypeLuggagePassengersForm.numSeats && record.body_type == this.rideTypeLuggagePassengersForm.bodyType
            })
            if (record) {
                return true
            }
            return false
        },
        rideTypeCapacityRecordExistsForSelectedRow(row) {
            let record = this.rideTypeCapacities.find(record => {
                return record.max_luggage == row.maxLug && record.num_seats == row.pax && record.body_type == row.bodyType
            })
            if (record) {
                return true
            }
            return false
        },
        bodyTypeSelected(bodyType) {
            this.rideTypeLuggagePassengersForm.bodyType = bodyType
        },
        updateRows() {
            if (!this.selectedCombinations.length) {
                this.saveRideTypeCapacity()
            } else {
                this.pushSelectedRows()
            }
        },
        saveRideTypeCapacity() {
            if (!this.$refs.luggageForm.validate()) {
                this.$snackbar.show('Please completely fill the form or select rows')
                return;
            }
            
            if (!this.rideTypeCapacityRecordExists()) {
                this.$store.dispatch('rideType/addRideTypeCapacity', this.rideTypeLuggagePassengersForm).then(response => {
                    this.$emit('saved')
                    this.$emit('closeDialog')
                })
            } else {
                this.$snackbar.error('This combination already exists')
            }
        },
        pushSelectedRows() {
            if (!this.selectedCombinations.length) {
                this.$snackbar.show('Please select rows')
                return;
            }
            this.$store.dispatch('rideType/addRideTypeCapacityRows', {rideTypeId: this.rideTypeLuggagePassengersForm.rideTypeId, rows: this.selectedCombinations}).then(response => {
                this.$emit('saved')
                this.$emit('closeDialog')
            })
        },
        closeDialog() {
            this.$emit('closeDialog')
        }
    }
}
</script>

<style scoped>

</style>